import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ShopNavbar from "./components/Navbar";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Register from "./pages/Register";

// Auth wrapper component
function RequireAuth({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
}

export default function App() {
  const [cart, setCart] = useState([]);
  const [cartId] = useState(1);
  const [user, setUser] = useState(null);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setUser({ username: "User" });
    } else {
      setUser(null);
    }
  }, []);

  const addToCart = (product) => {
    const normalized = {
      product_id: product.product_id,
      name: product.name,
      unit_price: parseFloat(product.price),
      quantity: 1,
      imageUrl: product.imageUrl || "",
    };

    setCart((prev) =>
      prev.find((p) => p.product_id === normalized.product_id)
        ? prev.map((p) =>
            p.product_id === normalized.product_id
              ? { ...p, quantity: p.quantity + 1 }
              : p
          )
        : [...prev, normalized]
    );
  };

  const removeFromCart = (product_id) => {
    setCart((prev) => prev.filter((p) => p.product_id !== product_id));
  };

  const changeQuantity = (product_id, newQty) => {
    setCart((prev) =>
      prev.map((item) =>
        item.product_id === product_id ? { ...item, quantity: newQty } : item
      )
    );
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <Router>
      <ShopNavbar cartCount={cart.length} user={user} onLogout={handleLogout} />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={<Login onLogin={(userData) => setUser(userData)} />}
        />
        <Route path="/register" element={<Register />} />

        {/* Protected Routes */}
        <Route
          path="/home"
          element={
            <RequireAuth>
              <Home cart={cart} addToCart={addToCart} removeFromCart={removeFromCart} />
            </RequireAuth>
          }
        />
        <Route
          path="/cart"
          element={
            <RequireAuth>
              <Cart cart={cart} onChangeQty={changeQuantity} removeFromCart={removeFromCart} />
            </RequireAuth>
          }
        />
        <Route
          path="/checkout"
          element={
            <RequireAuth>
              <Checkout cart={cart} cartId={cartId} />
            </RequireAuth>
          }
        />
      </Routes>
    </Router>
  );
}
